class HeroBannerParallax extends HTMLElement {
  constructor() {
    super();

    this.component = this.getBoundingClientRect();

    this.componentOffset = this.component.top + window.scrollY;
    this.componentHeight = this.component.height;

    this.componentBoundaryLower = this.componentOffset;
    this.componentBoundaryUpper = this.componentOffset + this.componentHeight;

    this.scrollPosition = window.scrollY;

    this.banners = Array.from(
      this.querySelectorAll(".hero-banner-parallax__banner")
    );
    this.bannersLastIndex = this.banners.length - 1;

    this.bannerHeight = this.banners[0].getBoundingClientRect().height;
    this.bannerOffset = Math.round(this.bannerHeight / 2);
    console.log("offset", this.bannerOffset);

    this.bannerBoundaryUpper = 0;
    this.bannerBoundaryLower = -this.bannerHeight;

    this.isPastComponent =
      this.scrollPosition >= this.componentBoundaryUpper ? true : false;

    this.bannerState = [];
    this.breakpoints = [];

    this.isVisible = false;
    this.isTicking = false;
    this.resizeFrame = false;

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.isVisible) this.isVisible = true;
        if (!entry.isIntersecting && this.isVisible) this.isVisible = false;
      });
    });

    this.observer.observe(this);
  }

  connectedCallback() {
    this.initializeComponent();
    this.handleScrollEvent();
    
    window.addEventListener("resize", () => {
      if (this.resizeFrame) cancelAnimationFrame(this.resizeFrame);

      this.resizeFrame = requestAnimationFrame(() => {
        this.handleResizeEvent();
        this.handleScrollEvent();
      });
    });

    window.addEventListener("scroll", () => {
      if (!this.isTicking && this.isVisible) {
        this.isTicking = true;
        requestAnimationFrame(() => {
          this.handleScrollEvent();
          this.isTicking = false;
        });
      }
    });
  }

  initializeComponent() {
    this.style.setProperty("--banner-count", this.banners.length);

    this.banners.forEach((banner, index) => {
      const object = {};
      const offset = index * this.bannerOffset;
      let bannerOffset = index * this.bannerOffset;

      if (index !== this.bannersLastIndex && this.isPastComponent)
        bannerOffset = (index - 1) * this.bannerOffset;
      if (index === 0 && this.isPastComponent)
        bannerOffset += this.bannerOffset;

      object.banner = banner;
      object.layer = -(index + 1);
      object.offset = bannerOffset;

      if (index === 0 && this.isPastComponent) 
        object.position = -this.bannerHeight / 2;
      else 
        object.position = 0;

      this.bannerState.push(object);
      this.breakpoints.push(this.componentOffset + offset);

      banner.style.zIndex = object.layer;
      banner.style.setProperty("--initial-position", bannerOffset + "px");
      
      if(index !== this.bannersLastIndex) banner.style.transform = `translateY(${bannerOffset - window.scrollY}px)`;
    });
  }

  handleScrollEvent() {
    const scrollY = window.scrollY;

    for (let i = 0; i < this.bannersLastIndex; i++) {
      const state = this.bannerState[i];
      const boundaryLower = this.breakpoints[i];
      const boundaryUpper = this.breakpoints[i + 1];
      const boundary = i != 0 && this.isPastComponent === true ? boundaryUpper : boundaryLower;

      if (scrollY >= boundaryLower && scrollY < boundaryUpper) state.position = Math.max(Math.round(boundary - scrollY), this.bannerBoundaryLower);
      if(scrollY > boundaryUpper) state.position = this.bannerBoundaryLower;
      
      state.banner.style.transform = `translateY(${state.position}px)`;
    }
  }

  handleResizeEvent() {
    this.component = this.getBoundingClientRect();
    this.componentOffset = this.component.top + window.scrollY;
    this.componentHeight = this.component.height;

    this.componentBoundaryLower = this.componentOffset;
    this.componentBoundaryUpper = this.componentOffset + this.componentHeight;

    this.scrollPosition = window.scrollY;

    this.bannerHeight = this.banners[0].getBoundingClientRect().height;
    this.bannerOffset = Math.round(this.bannerHeight / 2);

    this.bannerBoundaryUpper = 0;
    this.bannerBoundaryLower = -this.bannerHeight;

    this.isPastComponent =
      this.scrollPosition >= this.componentBoundaryUpper ? true : false;

    this.bannerState = [];
    this.breakpoints = [];

    this.initializeComponent();
  }
}

if (!customElements.get("hero-banner-parallax"))
  customElements.define("hero-banner-parallax", HeroBannerParallax);
